<template>
  <section class="hire">
    <h2>{{params.title}}</h2>
    <div class="contacts">
      <div class="contact" v-for="item in params.items">
        <img :src="item.img" :alt="item.title">
        <div class="contact__title">{{item.title}}</div>
        <div class="contact__value">{{item.text}}</div>
      </div>
    </div>
  </section>

</template>

<script>
export default {
  name: "VolunteerPageInformBlock",
  props:["params"]
}
</script>

<style scoped>

</style>